module.exports = __webpack_public_path__ + "img/upload-csv-big.fea05145.svg";